import { useAuth0 } from "@auth0/auth0-react"
import { useEffect } from "react"
import Loader from "./Components/BifrostPageComponent/Loader/Loader"
import DownForMaintenancePage from "./Pages/OtherPages/DownForMaintenancePage"
import AcceptUserTerms from "./Pages/OtherPages/UserLoginPage/AcceptUserTerms"

import "semantic-ui-css/semantic.min.css"

import "@global"
import "@reset"
import "@variables"

import { useGetUserInfo } from "./Hooks/FetchHooks/GetDataService/useGetUserInfo"
import Error401 from "./Pages/OtherPages/ErrorPage/Error401"
import Error503 from "./Pages/OtherPages/ErrorPage/Error503"
import ErrorAuth0 from "./Pages/OtherPages/ErrorPage/ErrorAuth0"
import Pages from "./Pages/Pages"
import UserInfoContext from "./store/userInfoContext"

const App = () => {
	const { isLoading: isLoadingForAuth, error: errorAuth0, isAuthenticated } = useAuth0()
	const { isLoading: isLoadingForGetUserInfo, data: userInfo, getUserInfo } = useGetUserInfo()

	let isDownForMaintenance = process.env.REACT_APP_DOWN_FOR_MAINTENANCE === "true"

	useEffect(() => !userInfo && isAuthenticated && getUserInfo(), [isAuthenticated, userInfo])

	return (
		<UserInfoContext.Provider value={userInfo}>
			{isDownForMaintenance ? (
				console.log(process.env.REACT_APP_VERSION),
				<DownForMaintenancePage />
			) : errorAuth0 ? (
				<ErrorAuth0 />
			) : userInfo && userInfo.terms_accepted === false ? (
				<AcceptUserTerms />
			) : isLoadingForAuth || isLoadingForGetUserInfo ? (
				<div style={{ height: "100vh" }}>
					<Loader />
				</div>
			) : !isAuthenticated ? (
				<Error401 />
			) : !userInfo ? (
				<Error503 />
			) : (
				<Pages isLoadingForGetUserInfo={isLoadingForGetUserInfo} isLoadingForAuth={isLoadingForAuth} />
			)}
		</UserInfoContext.Provider>
	)
}

export default App
